import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {environment} from "../../environments/environment";

@Injectable()
export class CustomerService {

  constructor(private http: HttpClient) {
  }

  checkApiKeyCustomer(api_key, total_value, description, verify, shipping_price, minutes, signature) {
    const url = environment.main_url + 'pc/check-api-key-customer';
    let params = new HttpParams();
    params = params.append('api_key', api_key);
    params = params.append('total_value', total_value);
    params = params.append('description', description);
    params = params.append('verify', verify);
    if (shipping_price) { params = params.append('shipping_price', shipping_price); }
    if (minutes) { params = params.append('minutes', minutes); }
    params = params.append('signature', signature);

    return this.http.get(url, {
      params: params
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/customer.service.ts